module.exports = __webpack_public_path__ + "1d581aa163d7701fa182f2223d67e485.svg";